import(/* webpackMode: "eager" */ "/vercel/path0/apps/d2c-sales-tool/src/app/global-error.tsx");
